exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".grid-element{position:absolute;cursor:move;z-index:2}.token{margin:10px;width:calc(100% - 20px);height:calc(100% - 20px);font-size:14px;line-height:28px;position:relative;background-color:#000;display:inline-block;text-align:center;color:#fff;font-family:Consolar,Courier New,Courier,monospace}.collision-marker{position:absolute;left:0;top:0;line-height:12px;font-size:12px;background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3aa5c548","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Grid/GridElement.vue
// module id = 23
// module chunks = 0